/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import AddUserDialog from "./AddUser";
import CreateBotDialog from "./CreateBot";
import UpdateMangerDialog from "./UpdateManager";

export const useAddUserDialog = (
  people,
  callback = () => {},
  displayNotification = () => {}
) => {
  const [open, setOpen] = useState(false);
  return {
    addUserDialog: (
      <AddUserDialog
        open={open}
        people={people}
        resetDialog={() => setOpen(false)}
        callback={callback}
        displayNotification={displayNotification}
      />
    ),
    setOpenAddUserDialog: () => setOpen(true),
  };
};

export const useCreateBotDialog = (
  callback = () => {},
  displayNotification = () => {}
) => {
  const [open, setOpen] = useState(false);
  return {
    createBotDialog: (
      <CreateBotDialog
        open={open}
        resetDialog={() => setOpen(false)}
        callback={callback}
        displayNotification={displayNotification}
      />
    ),
    setOpenCreateBotDialog: () => setOpen(true),
  };
};

export const useUpdateManagerDialog = (
  people,
  callback = () => {},
  displayNotification = () => {}
) => {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState({});
  return {
    updateManagerDialog: (
      <UpdateMangerDialog
        open={open}
        user={user}
        people={people}
        resetDialog={() => setOpen(false)}
        callback={callback}
        displayNotification={displayNotification}
      />
    ),
    setOpenUpdateManagerDialog: (user) => {
      setUser(user);
      setOpen(true);
    },
  };
};
